import { Component, EventEmitter, Input, Output } from '@angular/core'

@Component({
  selector: 'dmmp-general-search-result',
  templateUrl: './general-search-result.component.html',
})
export class GeneralSearchResultComponent {
  @Input() module: any
  @Input() identifier: string
  @Input() searchingResult: Array<any>
  @Input() initialResult: Array<any>
  @Output() redirectPage = new EventEmitter()
  @Input() currentSearch: string

}
